import { UsersIcon } from '@air/design-icons';

import { LibraryDetailsAccessibility } from '~/components/LibraryBeta/LibrarySettingsModal/components/LibraryDetails/components/LibraryDetailsAccessibility';

export const LibraryDetailsAccessibilityPublic = () => {
  return (
    <LibraryDetailsAccessibility
      description="Any workspace member can join this library"
      label="Public to workspace"
      icon={<UsersIcon size="sm" className="text-gray-10" />}
    />
  );
};
